import styled from 'styled-components';

export const ProductCards = styled.div`
  /* border-radius: ${(props) => (props.userType === 'A' ? '0' : '10px')}; */
  /* box-shadow: ${(props) =>
    props.userType === 'A' ? 'none' : '0 1px 2px 0 rgba(0, 0, 0, 0.2)'}; */
  position: relative;
  display: flex;
  flex-direction: column;
  border-radius: 4px;
  /* margin-bottom: ${(props) => (props.userType === 'A' ? '10px' : '0')}; */
  border: 1px solid hsl(0deg, 0%, 0%, 7%);
  &.lowOpacity {
    opacity: 0.4;
  }
  @media (min-width: 720px) {
    margin: 10px 8.5px;
  }
  &:hover {
    cursor: pointer;
  }
`;

export const ProductImage = styled.div`
  height: 0;
  flex-shrink: 0;
  padding-top: 134%;
  position: relative;

  span {
    height: 100% !important;
  }
  img {
    object-fit: ${(props) => props.imgFit};
    object-position: top;
  }
`;

export const ProductDetail = styled.div`
  padding: 10px 8px;
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const ProductName = styled.h4`
  font-size: clamp(15px, 2vw, 16px);
  padding: 0;
  font-weight: 400;
  @media (min-width: 720px) {
    font-size: 18px;
    padding-top: 10px;
  }
`;

export const ProductStyle = styled.span`
  font-size: 12px;
  color: #999999ab;
  padding: 4px 0;
  text-transform: capitalize;
`;

export const ProductPriceStrip = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 3px;
`;

export const Price = styled.span`
  font-weight: 600;
  font-size: clamp(12px, 2vw, 14px);
  padding: 4px 0;
  @media (min-width: 720px) {
    font-size: 16px;
  }
`;

export const StrikePrice = styled.span`
  color: #999999ab;
  text-decoration: line-through;
  padding: 0 4px;
  font-size: 12px;
  font-weight: 500;
  @media (min-width: 720px) {
    font-size: 14px;
  }
`;

export const Discount = styled.span`
  font-weight: 700;
  color: #63b0a8;
  font-size: clamp(8px, 2vw, 10px);
  padding: 4px 4px;
`;

export const LightningPrice = styled.div`
  display: flex;
  align-items: end;
  justify-content: start;
  margin: ${(props) => (props.categoryPage ? '5px 0 0' : '0 0 10px 0')};
  p {
    font-size: 12px;
    font-weight: 600;
    color: #ef4e5e;
    padding-left: 6px;
  }
  img {
    width: 8px;
  }
`;
